import { render } from "./edit-goods.vue?vue&type=template&id=5e2d23c8&scoped=true&ts=true"
import script from "./edit-goods.vue?vue&type=script&lang=ts"
export * from "./edit-goods.vue?vue&type=script&lang=ts"

import "./edit-goods.vue?vue&type=style&index=0&id=5e2d23c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2d23c8"]])

export default __exports__